import { Features } from './../../features/model/features.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { Roles } from '../../roles/model/roles.model';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(): Observable<any> {
        return this.get<any>(EndPoints.permissions_Index).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    create(role: Roles, feature: Features): Observable<any> {
        return this.post<any>(EndPoints.permissions_Create, false, '', {
            role: role,
            feature: feature
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deletePermission(role: Roles, feature: Features): Observable<any> {
        return this.post<any>(EndPoints.permissions_Delete, false, '', {
            role: role,
            feature: feature
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
